<div class="page-content start" id="top">

      <notice-box [hidden]="!isMSIE" tabindex="0" style="margin:0.4em">
                  <div class="bottom-margin" html='start.noSupport_1'></div>
                  <div html='start.noSupport_2'></div>
      </notice-box>

     <h1 class="page_title" translate='start.page_title' (click)="onClick()"></h1>

     <div translate='start.registerWithin30days'></div>

            <accordion label="start.accord_whatThisMean" outer-class="bottom-margin">
                  <div class="accord-start" translate='start.accord_startText'></div>
                  <ul>
                        <li translate='start.accord_noticeOfBirth'></li>  
                        <li [innerHTML]="'start.accord_completedByParents' | translate"></li>  
                  </ul>
                  <div translate='start.accord_endText'></div>
            </accordion>

     <div>
           <div translate='start.NRS_service_list'></div>
           <div class="service-margin">
                <div class="service-item">
                   <div class="service-confirm left-w5"><img src="assets/images/confirm.png"/></div>
                   <div class="service-text right-w94">
                        <strong translate='start.service_registgerBirth' class="service-title" ></strong>
                        <span   translate='start.service_registgerBirthText'></span>
                   </div>
                </div>  

                <div class="service-item">
                   <div class="service-confirm left-w5"><img src="assets/images/confirm.png"/></div>
                   <div class="service-text right-w94">
                       <strong translate='start.service_orderBC' class="service-title"></strong>
                       <span   translate='start.service_orderBCText'></span>
                   </div>
                </div>  
                  
                <div class="service-item">
                   <div class="service-confirm left-w5"><img src="assets/images/confirm.png"/></div>
                   <div class="service-text right-w94">
                     <strong translate='start.service_additional' class="service-title"></strong>
                     <span   translate='start.service_additionalText'></span>
                   </div>
                </div>  
           </div>

           <div class="bottom-margin">
               <span  translate='start.service_visit'></span>
               <a-link link-url="start.service_URL" 
                       alt-text="start.service_URL_alt" 
                          label='start.service_URL_label'
                          (click)="gtag(GA.Link,GA.onca_Newborn)"></a-link>
               <span translate='start.service_learnMore'></span>
           </div>
     
           <div class="btn-div">
                   <button class="btn-next"        alt-text="start.registerButton_alt" 
                          (click)="onNextClick()" translate="start.registerButton">
                   </button>
           </div>
</div>